export default __webpack_public_path__ + "static/media/default-avatar.4aa827c3.jpg";